import { Pipe, PipeTransform, inject } from '@angular/core';
import { StatusProdutoBeneficiario } from '../../models/beneficiario/StatusProdutoBeneficiario';
import { LabelService } from '../../services/label/label.service';

@Pipe({
  name: 'statusProdutoBeneficiario',
})
export class StatusProdutoBeneficiarioPipe implements PipeTransform {
  private labelService = inject(LabelService);

  transform(status: StatusProdutoBeneficiario): string {
    const statuses = {
      0: this.labelService.get('aguardandoComunicacaoProvedor'),
      1: this.labelService.get('aguardandoAtivacaoProvedor'),
      2: 'Ativo',
      3: 'Aguardando bloqueio',
      4: 'Bloqueado',
      5: 'Recusado',
    };

    return statuses[status];
  }
}
